import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, GetMessagesThreadsResponse, MessagesApi } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseMessagesThreadsStore {
  loading: boolean;
  data: GetMessagesThreadsResponse[] | null;
  error?: string | null;
  get: () => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useMessagesThreadsStore = create<UseMessagesThreadsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  get: async () => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await MessagesApi.getMessagesThreads();
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
